
import InvestmentController from './investments_controller'

export default class extends InvestmentController {
} 

